import * as d3 from 'd3';
import { CategoricalChartData } from './CategoricalChart.model';
import { NumberFormatHelper } from '../../..';

export class YAxis {
    private _yScale: d3.scale.Linear<number, number>;
    private _yAxis: d3.svg.Axis;
    private _yAxisGroup: d3.Selection<any>;
    private _width: number;
    private _height: number;

    constructor(container: d3.Selection<SVGGElement>, width: number, height: number) {
        this.init(container, width, height);
        this.width(width)
            .height(height);
    }

    private init(container: d3.Selection<SVGGElement>, width: number, height: number) {
        const yScale = d3.scale.linear()
            .domain([0, 1]);
        const yAxis = d3.svg.axis()
            .orient('left')
            .scale(yScale)
            .ticks(6);
        const yAxisGroup = container.append('g')
            .classed('axis', true)
            .attr('transform', `translate(${0},${0})`);

        this._yScale = yScale;
        this._yAxis = yAxis;
        this._yAxisGroup = yAxisGroup;
    }

    height(): number;
    height(value: number): this;
    height(value?: number): this | number {
        if (!arguments.length) {
            return this._height;
        }
        this._height = value;
        this._yScale
            .range([this._height, 0]);
        return this;
    }

    width(): number;
    width(value: number): this;
    width(value?: number): this | number {
        if (!arguments.length) {
            return this._width;
        }
        this._width = value;
        return this;
    }

    extent(): number[];
    extent(value: number[]): this;
    extent(value?: number[]): this | number[] {
        if (!arguments.length) {
            return this._yScale.domain();
        }
        this._yScale.domain(value);
        const extent = value;
        const fmt = NumberFormatHelper.getFormat(extent[0], extent[1]);
        this._yAxis.tickFormat(fmt);
        return this;
    }

    position(value: number): number {
        let pos = this._yScale(value);
        if (isNaN(pos)) {
            pos = 0;
        }
        return pos;
    }

    ticks(): number[] {
        const ticks = this._yScale.ticks(6);
        return ticks;
    }

    render(data: CategoricalChartData[]): void {
        this._yAxisGroup
            .transition()
            .call(this._yAxis);
        const ticks = this._yAxisGroup.selectAll('.tick');
        ticks.select('text')
            .classed('tickLabel', true);
    }
}